/* global app */
app.controller('dialog_simpleDisplayCtrl', ['$rootScope', '$scope', '$http', 'NetworkService', '$timeout', function ($rootScope, $scope, $http, NetworkService, $timeout) {
    
        $scope.fields = {};
        
        $rootScope.$on("simpleDisplayDialog", function(e, data){
           $scope.showImg = true;
        })
        
        
        $scope.hideImg = function(){
                $timeout(function(){
                        $scope.showImg = false;
                },1)
        }
    }])